export default __webpack_public_path__ + "static/fox-books-2949c8884bc6e79366171aa7cca5aa57.png";